module.exports = function(posts) {
	'use strict'
	posts.directive('postDir',postDir);
	postDir.$inject=[];
	function postDir() {
		return {
			template: require('./partial/edit-newPost.html'),
			controller:"postController",
			controllerAs:"vmp",
			link: function(scope, element, attrs, ctrl) {
				    
			}

		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/postsModule/edit-newpost/js/directive/postDirective.js
// module id = 559
// module chunks = 0